import React from "react";
import { FiEye } from "react-icons/fi";

const AuditionActionsCell = ({ roleApplicationId, onView }) => {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", margin: "0 auto" }}>
            <button
                type="button"
                style={{
                    background: "#2563eb",
                    backgroundColor: "#2563eb",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "6px",
                    width: "32px",
                    height: "32px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    padding: 0,
                    flexShrink: 0
                }}
                onClick={() => onView(roleApplicationId)}
                title="View Application"
            >
                <FiEye size={15} color="#ffffff" />
            </button>
        </div>
    );
};

export default AuditionActionsCell;
